import styled, { css } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

import { IGridCell } from "./rides.kanban.wrapper";

export const KanbanWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "rides-kanban-wrapper",
})`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-grow: 1;
  min-height: 0;
  height: 100%;
  background-color: ${rydeColors.smoke};
  display: grid;
  padding-inline-start: 20px;
  gap: 0 4px;
  grid-template-columns: 345px 345px 345px 1fr;
  grid-template-rows: 50px 1fr;
  grid-template-areas:
    "head1 head2 head3 map"
    "col1  col2  col3  map";

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const KanbanColumnStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "rides-kanban-column-wrapper",
})<IGridCell>`
  grid-area: ${({ $gridArea: gridArea }) => gridArea};
  position: relative;
  overflow-y: auto;
  scrollbar-gutter: stable;
  .drag_over .kanban_item {
    outline: 3px solid ${rydeColors.dragBorderColor};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  }
  .drag_not_allowed {
    opacity: 0.3;
  }
`;

export const KanbanColumnHeaderStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "rides-kanban-column-header",
})<IGridCell>`
  grid-area: ${({ $gridArea }) => $gridArea};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: 332px;
  align-items: center;
  ${({ $borderBottomColor }) =>
    !!$borderBottomColor &&
    css`
      border-bottom: 1px solid ${$borderBottomColor};
    `};
  span {
    color: ${greyMui._900};
  }
  label {
    margin-inline-start: 7px;
    color: ${blueGreyMui._400};
  }
`;

export const KanbanMapStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "kanban-map",
})<IGridCell>`
  grid-area: ${({ $gridArea: gridArea }) => gridArea};
  background-color: ${rydeColors.smoke};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  z-index: ${ScreenDepth.MAIN_CONTAINER};
  overflow-x: auto;
  div.map_scrollable_content {
    min-width: max(100%, 450px);
    height: 100%;
  }
`;
